import { GroupMemberPermission } from 'constants/group'
import { AuthRole } from 'interfaces/auth'
import { IUser } from 'interfaces/user'

export interface IGroup {
  id?: number
  name: string
  createdAt?: Date
  updatedAt?: Date
  description?: string
  isCompanyGroup?: boolean
  archived?: boolean
  isDeleted?: boolean
  organizationId: number

  // INFO aggregate value for display
  numberOfMembers?: number
  numberOfCollections?: number
}

export interface IGroupMember {
  id?: number
  memberId?: number
  groupId: number
  permissionId?: number
  memberType?: string
  admin?: boolean
  group?: IGroup
  member?: IUser
}

export interface IGroupMemberPermission {
  id: IGroupMemberPermissionId
  name: GroupMemberPermission
}

export enum IGroupMemberPermissionId {
  ADMIN = 1,
  EDITOR = 2,
  OWNER = 3,
  VIEWER = 4
}

export interface IUserWithGroupPermission extends IUser {
  permission?: IGroupMemberPermission
  authRole?: AuthRole
  groupMemberId: number
}

export interface IGroupDetail extends IGroup {
  members: IGroupMember[]
  numberOfMembers?: number
}

export type IUserInGroup = Pick<
  IUser,
  'id' | 'firstName' | 'lastName' | 'lastSignInAt' | 'email' | 'ssoEmail' | 'ssoEmailVerified' | 'organizationId' | 'disabled' | 'username' | 'image'
>

export interface IGroupMemberDetail extends IUserInGroup {
  permission: IGroupMemberPermission
  permissionId?: IGroupMemberPermissionId
  authRole: AuthRole
  groupId: number
  groupMemberId: number
}

export interface IAggregateGroupMemberResult {
  paginatedResult: IGroupMemberDetail[]
  totalCount: number
}
